<template>
  <teleport to="#defaultPop">
      <!-- 평가원 스탠다드 권한부여 -->
      <ApprovedStandard v-if="isApprovedStandard"/> 
      <OrgEvalDist v-if="isOrgEvalDist"/> 
      <DistributionStatus v-if="isDistributionStatus"/> 
      <GiasStatus v-if="isGiasStatus"/> 
      <OrgStandardDistribution v-if="isOrgApprovedStandard"/> 
  </teleport>
  <Home />
</template>

<script setup>
import Home from '@/layouts/home'
import ApprovedStandard from '@/layouts/popup'
import OrgEvalDist from '@/layouts/popup/orgEvalDist'
import DistributionStatus from '@/layouts/popup/distStatPopup'
import GiasStatus from '@/layouts/popup/giasStatPopup'
import OrgStandardDistribution from '@/layouts/popup/orgStandardDistribution'
import * as Utils from '@/common/util/util'
import { onBeforeMount, computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

const store = useStore()
const router = useRouter()
const route = useRoute()
const {  
  isApprovedStandard,
  isDistributionStatus,
  isGiasStatus,
  isOrgApprovedStandard,
  isOrgEvalDist,
} = toRefs(store.state.temp) 

onBeforeMount(async () => {
  const checkUserId = computed(() => store.state.temp.userInfo);

  // 로그인이 필요 없는 경로 목록
  const publicPaths = ["/login", "/evalJoin", "/join", "/orgJoin","/joinType","/findID","/findPW","/joinType",'/'];

  // 라우터 초기화 대기
  await router.isReady(); // 라우터가 초기화될 때까지 대기

  if (route.path === "/login") return;
  
  // 현재 경로가 로그인이 필요 없는 경로인지 확인
  const isPublicPath = publicPaths.includes(route.path);

  if (!isPublicPath && (!checkUserId.value.memberCode || checkUserId.value.memberCode === "")) {
    store.commit("temp/clearUserInfo");
    store.commit("grid/clearSearchParam");
    alert("로그인이 필요한 서비스입니다.");
    router.push("/login"); // 로그인 페이지로 이동
  }
});


</script>

